var React = require('react');

function Contact (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"contact"),React.createElement("rect",{"x":"0.5","y":"0.5","width":"12.1","height":"8.5","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round"},"key":1}),React.createElement("polyline",{"points":"0.5 0.5 6.5 5.2 12.6 0.5","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round"},"key":2})]);
}

Contact.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 13.1 9.5"};

module.exports = Contact;

Contact.default = Contact;
